import React from "react";
import NumberFormat from "react-number-format";

interface PeriodNumberFormatProps {
  inputRef: (instance: NumberFormat | null) => void;
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  [key: string]: any;
}

// MM/YYYY masked input for the Accounting Period / Policy Month-Year header
// searches: digits only, slash inserted automatically, nothing past the 4-digit
// year. react-number-format is v4 here, so the pattern char is always "#".
const PeriodNumberFormat = ({
  inputRef,
  onChange,
  name,
  ...rest
}: PeriodNumberFormatProps) => (
  <NumberFormat
    {...rest}
    getInputRef={inputRef}
    format="##/####"
    mask="_"
    // Reject 00 and 13-99 as the month is typed, the same way
    // PercentNumberFormat caps its value at 100.
    isAllowed={({ value }: any) => {
      const month = value.slice(0, 2);
      if (month.length < 2) return true;
      return Number(month) >= 1 && Number(month) <= 12;
    }}
    // Emits the FORMATTED value ("04/2026"), unlike DecimalNumberFormat which
    // emits raw digits: toPeriodCode needs the slash to tell MM/YYYY apart from
    // a pasted YYYYMM.
    onValueChange={(values: any) => {
      onChange({ target: { name, value: values.formattedValue } });
    }}
    name={name}
  />
);

export default PeriodNumberFormat;
